import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
`;

export const ModalContainer = styled.div`
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
    overflow: hidden;
    animation: modalSlideIn 0.3s ease-out;

    @keyframes modalSlideIn {
        from {
            opacity: 0;
            transform: translateY(-30px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @media (max-width: 768px) {
        max-width: 90%;
        margin: 0 20px;
    }
`;

export const ModalHeader = styled.div`
    padding: 30px 30px 20px;
    text-align: center;
    background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
    color: white;
`;

export const ModalIcon = styled.div`
    font-size: 3rem;
    margin-bottom: 15px;
`;

export const ModalTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
`;

export const ModalContent = styled.div`
    padding: 25px 30px;
`;

export const ModalText = styled.p`
    font-size: 1.1rem;
    line-height: 1.6;
    color: #555;
    text-align: center;
    margin: 0;
`;

export const ModalActions = styled.div`
    padding: 20px 30px 30px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ModalButton = styled.button`
    padding: 12px 24px;
    border-radius: 30px;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    text-align: center;

    ${props => props.primary && `
        background: var(--primary-color, #007bff);
        color: white;
        
        &:hover {
            background: var(--primary-color-dark, #0056b3);
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
        }
    `}

    ${props => props.secondary && `
        background: #28a745;
        color: white;
        
        &:hover {
            background: #218838;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);
        }
    `}

    ${props => props.outline && `
        background: transparent;
        color: #666;
        border: 2px solid #ddd;
        
        &:hover {
            background: #f8f9fa;
            border-color: #999;
            color: #333;
        }
    `}

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    }

    @media (max-width: 768px) {
        padding: 14px 24px;
        font-size: 1rem;
    }
`;
